import { render, staticRenderFns } from "./IconCalendar.vue?vue&type=template&id=cf6fb42a&scoped=true&"
import script from "./IconCalendar.vue?vue&type=script&lang=js&"
export * from "./IconCalendar.vue?vue&type=script&lang=js&"
import style0 from "./IconCalendar.vue?vue&type=style&index=0&id=cf6fb42a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6fb42a",
  null
  
)

export default component.exports